export const BRAND = "NXHOST";
export const TAGLINE = "Seu sucesso é o nosso negócio.";

// Origem canônica do site. Definida em VITE_SITE_URL (variável de ambiente do projeto).
const RAW_SITE_URL = import.meta.env.VITE_SITE_URL as string | undefined;

/** Origem do site sem barra final, usada em canonical, Open Graph e JSON-LD. */
export const SITE_URL =
  (RAW_SITE_URL && RAW_SITE_URL.trim().replace(/\/+$/, "")) || "https://nxhost.com.br";

export const SITE_NAME = "NXHOST";
export const TWITTER_HANDLE = "@nxhost";

// Assets de marca
// Logo (PNG com fundo transparente) — usado no topo, rodapé e favicon.
export const BRAND_LOGO_URL =
  "https://public.readdy.ai/ai/img_res/feed1798-3a02-4207-96a8-c4fb2aedc1b5.png";
// Imagem de compartilhamento (Open Graph / Twitter) 1200x630 com o logo em destaque.
export const BRAND_OG_IMAGE =
  "https://public.readdy.ai/ai/img_res/edited_c69f837bc56d3268a309bf6aa82d9732_c216b483.jpg";

// Imagens de produto usadas nos dados estruturados (JSON-LD) de cada linha de planos.
// Hospedagem de sites
export const PLAN_IMAGE_HOSTING =
  "https://readdy.ai/api/search-image?query=Stylized%20minimal%203D%20illustration%20of%20web%20hosting%20infrastructure%2C%20floating%20glass%20server%20cards%20and%20a%20small%20globe%20with%20soft%20green%20connection%20lines%2C%20warm%20cream%20neutral%20background%2C%20clean%20editorial%20render%20with%20soft%20shadows%2C%20premium%20harmonious%20composition&width=1200&height=900&seq=nx-plan-hosting-01&orientation=landscape";
// VPS e servidores virtuais
export const PLAN_IMAGE_VPS =
  "https://readdy.ai/api/search-image?query=Stylized%20minimal%203D%20illustration%20of%20virtual%20private%20server%20resources%2C%20floating%20glass%20CPU%20and%20cloud%20modules%20linked%20by%20soft%20green%20light%20lines%2C%20warm%20cream%20neutral%20background%2C%20clean%20editorial%20render%20with%20soft%20shadows%2C%20premium%20harmonious%20composition&width=1200&height=900&seq=nx-plan-vps-01&orientation=landscape";
// Servidores dedicados
export const PLAN_IMAGE_DEDICATED =
  "https://readdy.ai/api/search-image?query=Stylized%20minimal%203D%20illustration%20of%20a%20dedicated%20server%20rack%20with%20glowing%20green%20status%20lights%20in%20a%20clean%20abstract%20data%20center%2C%20warm%20cream%20neutral%20background%2C%20editorial%20render%20with%20soft%20shadows%2C%20premium%20harmonious%20composition&width=1200&height=900&seq=nx-plan-dedicated-01&orientation=landscape";

export const WHATSAPP_NUMBER = "5554996542326";
export const WHATSAPP_DISPLAY = "54 99654-2326";
export const WHATSAPP_LINK = "https://wa.me/5554996542326";

export const CONTACT_EMAIL = "vendas@nxhost.com.br";

export const CLIENT_AREA_URL = "https://nxhost.com.br/cliente/login";

export const WHATSAPP_MESSAGE =
  "Ola! Quero falar com um especialista da NXHOST sobre hospedagem e soluções digitais.";

export function whatsappLink(message: string = WHATSAPP_MESSAGE): string {
  return `${WHATSAPP_LINK}?text=${encodeURIComponent(message)}`;
}